import api from '@/api';

export interface ApiKeyMeta {
  id: string;
  aid?: string;
  label: string;
  previewPrefix: string;
  createdAt: number;
  lastUsedAt?: number | null;
}

export interface CreateApiKeyResult {
  status: string;
  keyId: string;
  apiKey: string;
  previewPrefix: string;
  message: string;
}

export async function listApiKeys(): Promise<ApiKeyMeta[]> {
  const { data } = await api.get<{ status: string; keys: ApiKeyMeta[] }>('/preference/api-keys');
  return Array.isArray(data?.keys) ? data.keys : [];
}

export async function createApiKey(label?: string): Promise<CreateApiKeyResult> {
  const { data } = await api.post<CreateApiKeyResult>('/preference/api-keys', {
    label: label?.trim() || 'API key',
  });
  return data;
}

export async function revokeApiKey(keyId: string): Promise<void> {
  await api.delete(`/preference/api-keys/${encodeURIComponent(keyId)}`);
}

export function apiBaseUrlForIntegrations(): string {
  return (
    import.meta.env.VITE_API_BASE_URL ||
    'http://localhost:5001/trovepile-39142/us-central1/api'
  ).replace(/\/$/, '');
}

export function buildCursorMcpConfig(apiKey: string): string {
  const base = apiBaseUrlForIntegrations();
  return JSON.stringify(
    {
      mcpServers: {
        trove: {
          command: 'node',
          args: ['packages/trove-mcp/dist/index.js'],
          env: {
            TROVE_API_BASE_URL: base,
            TROVE_API_KEY: apiKey,
          },
        },
      },
    },
    null,
    2
  );
}
